import React from "react";

function CustomSelect({label, name, value, options, onChange  }) {
  return (
    <div>
      <label htmlFor={name}>{label}</label>
      <select  
      // label={label}
        name={name}
        value={value}
        onChange={onChange} className="form-control">
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default CustomSelect;
